import { toast } from "sonner";
import { Instagram, Pin, MessageSquare, Link2 } from "lucide-react";

export const ShareArtwork = ({ art, imageUrl }) => {
  const previewUrl = imageUrl ? imageUrl.replace("/api/files/", "/api/files/preview/") : "";
  const url = window.location.href;
  const text = `"${art.title}" — Fine Art by Jason`;

  const copy = async (msg) => {
    try { await navigator.clipboard.writeText(url); toast.success(msg || "Link copied"); }
    catch { toast.error("Could not copy link"); }
  };

  const instagram = async () => {
    if (navigator.share) {
      try {
        const payload = { title: art.title, text, url };
        if (previewUrl && navigator.canShare) {
          const blob = await fetch(previewUrl).then(r => r.blob());
          const file = new File([blob], "fine-art-by-jason-preview.jpg", { type: "image/jpeg" });
          if (navigator.canShare({ files: [file] })) payload.files = [file];
        }
        await navigator.share(payload); return;
      } catch (err) {
        if (err?.name === "AbortError") return; // user dismissed the share sheet
        console.error("Native share failed, falling back to copy", err);
      }
    }
    await copy("Link copied — paste it into your Instagram story or bio");
    window.open("https://www.instagram.com/", "_blank", "noopener");
  };

  const pinterest = () => {
    const u = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(previewUrl)}&description=${encodeURIComponent(text)}`;
    window.open(u, "_blank", "noopener,width=750,height=620");
  };

  const sms = () => { window.location.href = `sms:?&body=${encodeURIComponent(`${text} ${url}`)}`; };

  const btn = "inline-flex items-center gap-2 px-3 py-2 text-[11px] uppercase tracking-[0.18em] border border-line hover:border-ink hover:bg-ink hover:text-cream transition-colors duration-200";
  return (
    <div className="flex flex-wrap gap-2" data-testid="share-artwork">
      <button onClick={instagram} className={btn} data-testid="share-instagram"><Instagram size={13}/> Instagram</button>
      <button onClick={pinterest} className={btn} data-testid="share-pinterest"><Pin size={13}/> Pinterest</button>
      <button onClick={sms} className={btn} data-testid="share-text"><MessageSquare size={13}/> Text</button>
      <button onClick={() => copy()} className={btn} data-testid="share-copy-link"><Link2 size={13}/> Copy Link</button>
    </div>
  );
};
